import { TextInput, TextInputProps } from "@mantine/core"

import { useDebouncedStateWithCallback } from "../hooks/useDebouncedStateWithCallback"

type DebouncedTextInputProps = {
  delay?: number | undefined
  inputValue: string
  onChange: (value: string) => void

  label: React.ReactNode
  labelProps?: TextInputProps

  onOpen: () => void
} & TextInputProps

export const DebouncedTextInput = ({
  delay = 1000,
  inputValue,
  onChange,
  onOpen,
  label,
  labelProps,
  ...props
}: DebouncedTextInputProps) => {
  const [value, handleChange] = useDebouncedStateWithCallback(
    inputValue,
    (newValue) => {
      onChange(newValue)
      onOpen()
    },
    delay
  )

  return (
    <TextInput
      {...props}
      labelProps={labelProps}
      label={label}
      value={value}
      onChange={(e) => handleChange(e.target.value)}
    />
  )
}
